import React from 'react'

const ParticularProjectPage = () => {
  return (
    <div>ParticularProjectPage</div>
  )
}

export default ParticularProjectPage